import React from 'react';
import Jquery from 'jquery';
import 'bootstrap';
import { KORECONX_URL } from '../../config';

class Kyc extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  componentDidMount = () => {
    var x = document.createElement('SCRIPT');
    x.id = 'kcxScriptSrc';
    x.src = `${KORECONX_URL}`;

    document.body.appendChild(x);
    Jquery('button').on('click', function () {
      return false;
    });
  };

  render() {
    return (
      <button
        style={{ width: 'inherit', marginRight: 10 }}
        data-buttonname='entroinvest'
        data-listing_id='150'
        className='kcxHinvestProcessForm button small w-button'
      >
        Start Investment
      </button>
    );
  }
}

export default Kyc;



// WEBPACK FOOTER //
// ./src/components/ExternalInvestApi/Kcx.js